var _a, _b;
import React from 'react';
import styled from 'styled-components';
import { Wrapper } from '../styled';
import { Header } from '../components';
import Snackbar from '../../Snackbar';
const illustrationClosed = (_a = require('../media/Illustrations/illustrationClosed.svg')) === null || _a === void 0 ? void 0 : _a.default;
const number401 = (_b = require('../media/Illustrations/401.svg')) === null || _b === void 0 ? void 0 : _b.default;
const Content = styled.div `
  display: flex;
  justify-content: center;
  padding: 56px 24px;
  margin-bottom: 64px;
  height: calc(100vh - 128px);
  max-width: 1440px;
  margin: auto;
  @media (min-width: 1024px) {
    padding: 56px 72px;
    justify-content: space-between;
  }
  @media (min-width: 1280px) {
    flex-direction: row;
    justify-content: space-between;
  }
`;
const IllustrationWrapper = styled.div `
  display: none;
  @media (min-width: 1024px) {
    width: 600px;
    display: block;
    margin: auto 0;
  }
`;
const Number401 = styled.img `
  width: 165px;
  height: 78px;
  align-self: center;
  margin-bottom: 32px;
  @media (min-width: 768px) {
    width: 238px;
    height: 112px;
  }
`;
const Wrapper401 = styled.div `
  max-width: 512px;
  a:focus {
    outline: 0;
  }
  a:hover {
    text-decoration: none;
    color: #fff;
  }
  @media (min-width: 1024px) {
    margin-right: 72px;
  }
`;
const Title = styled.div `
  font-size: 32px;
  font-weight: bold;
  line-height: 1.25;
  letter-spacing: -0.01px;
  color: #29333d;
  margin-bottom: 16px;
`;
const Description = styled.div `
  font-size: 14px;
  line-height: 1.43;
  letter-spacing: 0.04px;
  text-align: justify;
  color: #697d8e;
  margin-bottom: 12px;

  ul {
    padding: 0 17px;
  }
`;
const DescriptionHeader = styled(Description) `
  font-weight: bold;
  color: #29333d;
`;
const Button = styled.button `
  width: 100%;
  height: 48px;
  border-radius: 25px;
  background: #006dff;
  font-size: 16px;
  font-weight: bold;
  line-height: 1.38;
  letter-spacing: 0.04px;
  text-align: center;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-family: 'DM Sans', sans-serif;
  margin-bottom: 32px;
  border: none;

  &:focus {
    outline: 0;
  }
  &:disabled {
    cursor: not-allowed;
    background: #e1e6ea;
    color: #899bad;
  }

  @media (min-width: 1024px) {
    width: 233px;
  }
`;
const Box401 = ({ translations, onClick, variant, showButton, showBar, closeBar, disabled, }) => {
    const { title, description, buttonText, snackbarMessage, reasonsHeader, reasons, contactHeader, contactInfo, } = translations;
    return (React.createElement(Wrapper, null,
        React.createElement(Snackbar, { open: showBar, handleClose: closeBar, message: snackbarMessage, variant: variant, autoHideDuration: 4000, showIcon: true }),
        React.createElement(Header, null),
        React.createElement(Content, null,
            React.createElement(Wrapper401, null,
                React.createElement(Number401, { src: number401 }),
                React.createElement(Title, null, title),
                React.createElement(Description, null, description),
                showButton && (React.createElement(Button, { disabled: disabled, onClick: onClick }, buttonText)),
                React.createElement(DescriptionHeader, null, reasonsHeader),
                React.createElement(Description, null,
                    React.createElement("ul", null, reasons && reasons.map((reason) => React.createElement("li", null, reason)))),
                React.createElement(DescriptionHeader, null, contactHeader),
                React.createElement(Description, null, contactInfo)),
            React.createElement(IllustrationWrapper, null,
                React.createElement("img", { src: illustrationClosed })))));
};
export default Box401;
